declare namespace $ {

	type $mol_select__dictionary_bog_theme_demo_1 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['theme_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_theme_demo_2 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['theme_current'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_theme_demo_3 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['theme_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_form_field__name_bog_theme_demo_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_theme_demo_5 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['Theme_select'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $bog_theme_toggle__theme_auto_bog_theme_demo_6 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $mol_number__value_bog_theme_demo_7 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['hue'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__precision_change_bog_theme_demo_8 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_bog_theme_demo_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_theme_demo_10 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['Hue'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_number__value_bog_theme_demo_11 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['hue_spread'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__precision_change_bog_theme_demo_12 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_bog_theme_demo_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_theme_demo_14 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['Hue_spread'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_number__value_bog_theme_demo_15 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['sat'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__precision_change_bog_theme_demo_16 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_bog_theme_demo_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_theme_demo_18 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['Sat'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_number__value_bog_theme_demo_19 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['lig'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__precision_change_bog_theme_demo_20 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_bog_theme_demo_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_theme_demo_22 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['Lig'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_row__sub_bog_theme_demo_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $bog_theme_demo_bar__series_x_bog_theme_demo_24 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['bar_x'] >
		,
		ReturnType< $bog_theme_demo_bar['series_x'] >
	>
	type $bog_theme_demo_bar__series_y_bog_theme_demo_25 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['bar_y'] >
		,
		ReturnType< $bog_theme_demo_bar['series_y'] >
	>
	type $bog_theme_demo_bar__sat_bog_theme_demo_26 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['sat'] >
		,
		ReturnType< $bog_theme_demo_bar['sat'] >
	>
	type $bog_theme_demo_bar__lig_bog_theme_demo_27 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['lig'] >
		,
		ReturnType< $bog_theme_demo_bar['lig'] >
	>
	type $mol_plot_pane__hue_base_bog_theme_demo_28 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['hue'] >
		,
		ReturnType< $mol_plot_pane['hue_base'] >
	>
	type $mol_plot_pane__hue_shift_bog_theme_demo_29 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['hue_spread'] >
		,
		ReturnType< $mol_plot_pane['hue_shift'] >
	>
	type $mol_plot_pane__graphs_bog_theme_demo_30 = $mol_type_enforce<
		ReturnType< $bog_theme_demo['bars'] >
		,
		ReturnType< $mol_plot_pane['graphs'] >
	>
	type $bog_theme_demo_case__theme_bog_theme_demo_31 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_demo_case['theme'] >
	>
	type $bog_theme_demo_case__theme_bog_theme_demo_32 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_demo_case['theme'] >
	>
	type $bog_theme_demo_case__theme_bog_theme_demo_33 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_demo_case['theme'] >
	>
	type $bog_theme_demo_case__theme_bog_theme_demo_34 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_demo_case['theme'] >
	>
	type $bog_theme_demo_case__title_bog_theme_demo_35 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_demo_case['title'] >
	>
	type $bog_theme_demo_case__inner_bog_theme_demo_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_demo_case['inner'] >
	>
	type $mol_scroll__sub_bog_theme_demo_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	export class $bog_theme_demo extends $mol_example_large {
		Theme( ): $bog_theme_auto
		hue_deg( ): string
		hue_spread_deg( ): string
		theme_dictionary( ): Record<string, any>
		theme_current( next?: string ): string
		theme_options( ): readonly(string)[]
		Theme_select( ): $mol_select
		Theme_field( ): $mol_form_field
		Theme_toggle( ): $bog_theme_toggle
		hue( next?: number ): number
		Hue( ): $mol_number
		Hue_field( ): $mol_form_field
		hue_spread( next?: number ): number
		Hue_spread( ): $mol_number
		Hue_spread_field( ): $mol_form_field
		sat( next?: number ): number
		Sat( ): $mol_number
		Sat_field( ): $mol_form_field
		lig( next?: number ): number
		Lig( ): $mol_number
		Lig_field( ): $mol_form_field
		Config( ): $mol_row
		bar_x( id: any): readonly(number)[]
		bar_y( id: any): readonly(number)[]
		Bar( id: any): $bog_theme_demo_bar
		bars( ): readonly(any)[]
		Plot( ): $mol_plot_pane
		Base( ): $bog_theme_demo_case
		Current( ): $bog_theme_demo_case
		Special( ): $bog_theme_demo_case
		Accent( ): $bog_theme_demo_case
		Cases( ): $bog_theme_demo_case
		Scroll( ): $mol_scroll
		plugins( ): readonly(any)[]
		style( ): ({ 
			'--mol_theme_hue': ReturnType< $bog_theme_demo['hue_deg'] >,
			'--mol_theme_hue_spread': ReturnType< $bog_theme_demo['hue_spread_deg'] >,
		}) 
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
	type $mol_button_copy__title_bog_theme_demo_case_1 = $mol_type_enforce<
		ReturnType< $bog_theme_demo_case['title'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_row__sub_bog_theme_demo_case_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_list__rows_bog_theme_demo_case_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__title_bog_theme_demo_case_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_list__rows_bog_theme_demo_case_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $bog_theme_demo_case extends $mol_view {
		theme( ): string
		Card2_text( ): $mol_button_copy
		Card2( ): $mol_row
		Card1_text( ): $mol_button_copy
		Card1( ): $mol_list
		Back( ): $mol_button_copy
		Line( ): $mol_button_copy
		Text( ): $mol_button_copy
		Field( ): $mol_button_copy
		Shade( ): $mol_button_copy
		Focus( ): $mol_button_copy
		Control( ): $mol_button_copy
		Hover( ): $mol_button_copy
		Current( ): $mol_button_copy
		Special( ): $mol_button_copy
		Self( ): $mol_list
		title( ): ReturnType< $bog_theme_demo_case['theme'] >
		sub( ): readonly(any)[]
		inner( ): readonly(any)[]
	}
	
	export class $bog_theme_demo_bar extends $mol_plot_bar {
		sat( next?: number ): number
		lig( next?: number ): number
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map